import { PlanoOperacionalTalhao } from "core/features/maps/typings";
import { TalhaoStore } from "./useTalhoesStore";

export type DesvincularEligibility = {
  canDesvincular: boolean;
  idsToDelete: string[];
  codigosTalhoes: string[];
  planoId: string | null;
};

const AVAILABLE_STYLE = {
  fillColor: "#CECECE",
  fillOpacity: 1,
  strokeColor: "#FFFFFF",
  strokeOpacity: 1,
  strokeWeight: 2,
};


export function evaluateDesvincularEligibility(
  map: google.maps.Map | null,
  planoOperacionalIds: TalhaoStore[],
  talhaoIds: TalhaoStore[]
): DesvincularEligibility {
  const empty: DesvincularEligibility = {
    canDesvincular: false,
    idsToDelete: [],
    codigosTalhoes: [],
    planoId: null,
  };

  if (!map || planoOperacionalIds.length !== 1 || talhaoIds.length === 0) {
    return empty;
  }

  const planoId = planoOperacionalIds[0].id;
  const selectedIds = new Set(talhaoIds.map((t) => t.id));
  const idsToDelete: string[] = [];
  const codigosTalhoes: string[] = [];
  let foundCount = 0;
  let allLinked = true;
  let anyWithOS = false;

  map.data.forEach((feature) => {
    const id = feature.getProperty("id") as string;
    if (!id || !selectedIds.has(id)) return;

    foundCount += 1;

    const planos =
      (feature.getProperty("planosoperacionais") as PlanoOperacionalTalhao[] | undefined) ??
      [];
    const vinculos = planos.filter((p) => p.PlanoOperacionalId === planoId);

    if (vinculos.length === 0) {
      allLinked = false;
      return;
    }

    if (vinculos.some((p) => p.PossuiOSAberta === true)) {
      anyWithOS = true;
      return;
    }

    vinculos.forEach((p) => {
      if (p.PlanoOperacionalOperacaoTalhaoId) {
        idsToDelete.push(p.PlanoOperacionalOperacaoTalhaoId);
      }
    });

    const codigo = feature.getProperty("codigo") as string;
    if (codigo) {
      codigosTalhoes.push(String(codigo));
    }
  });

  const canDesvincular =
    foundCount === talhaoIds.length &&
    allLinked &&
    !anyWithOS &&
    idsToDelete.length > 0;

  return {
    canDesvincular,
    idsToDelete,
    codigosTalhoes,
    planoId,
  };
}

export function formatTalhoesList(codigos: string[]): string {
  if (codigos.length === 0) return "";
  if (codigos.length === 1) return codigos[0];
  if (codigos.length === 2) return `${codigos[0]} e ${codigos[1]}`;

  const allButLast = codigos.slice(0, -1).join(", ");
  return `${allButLast} e ${codigos[codigos.length - 1]}`;
}


export function updateMapAfterDesvincular(
  map: google.maps.Map | null,
  talhaoIds: string[],
  planoId: string
): void {
  if (!map || !planoId || talhaoIds.length === 0) return;

  const idsSet = new Set(talhaoIds);

  map.data.forEach((feature) => {
    const id = feature.getProperty("id") as string;
    if (!id || !idsSet.has(id)) return;

    const planos =
      (feature.getProperty("planosoperacionais") as PlanoOperacionalTalhao[] | undefined) ??
      [];
    const novosPlanos = planos.filter((p) => p.PlanoOperacionalId !== planoId);
    feature.setProperty("planosoperacionais", novosPlanos);
    feature.setProperty("__color", AVAILABLE_STYLE.fillColor);

    map.data.overrideStyle(feature, AVAILABLE_STYLE);
  });
}
